import React from 'react';
import { Box, Grid, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';


const UserInputField = ({ label, value, onChange, disabled=false }) => {
  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mb={1}>
      <Box>
        <Typography sx={{ fontFamily: 'Montserrat', fontSize: '20px', fontWeight: 'bold', color:'#567D8C' }}>
          {label}
        </Typography>
        
        <TextField
          fullWidth
          disabled={disabled}
          variant="standard"
          value={value}
          inputProps={{ maxLength: 80 }}
          onChange={onChange}
          sx={{
            "& .MuiInputBase-input": {
              fontFamily: "Montserrat",
              fontSize: "14px",  
              fontWeight: 500,
              color: "#000000bb", 
              paddingY: "6px",
            },

            // Barra inferior
            "& .MuiInput-underline:before": {
              borderBottomColor: "#E0E0E0",
              borderBottomWidth: "2px",
            },

            // Barra inferior hover
            "& .MuiInput-underline:hover:before": {
              borderBottomColor: "#567D8C",
            },

            // Barra inferior  focus 
            "& .MuiInput-underline:after": {
              borderBottomColor: "#1D3D4D", 
              borderBottomWidth: "2px",
            },

            // Disabled: texto y barra
            "& .MuiInputBase-root.Mui-disabled": {
              color: "#00000061",
            },
            "& .MuiInputBase-root.Mui-disabled:before": {
              borderBottomStyle: "solid",
              borderBottomColor: "#D0D0D0",
            },
          }}
        />
      </Box>
    </Grid>
  );
};

UserInputField.propTypes = {
  lavel: PropTypes.func.isRequired,
  value: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default UserInputField;
